























































import Vue from 'vue';
import { LoadOverlay } from '@wsb/wsb-uibase';
import Global from '@/global';
import * as JsBase from '@wsb/wsb-jsbase';

export default Vue.extend({
  name: 'Instellingen',
  data: () => ({
    loading: false,
    info: {
      usr: '',
      email: '',
      mfaEnabled: null as boolean|null
    },
    dialog: {
      show: false
    }
  }),
  methods: {
    async tryInBackground<T>(fnc: () => Promise<T>) {
      this.loading = true;
      try {
        await fnc();
      } catch (e) {
        JsBase.Events.RaiseExceptionOccurred(e);
      } finally {
        this.loading = false;
      }
    },
    load() {
      this.tryInBackground(async () => {
        var tok = await Global.Auth.GetToken();
        this.info.usr = tok.sub;

        const req = await Global.Auth.configureRequest(new Request(`${Global.ApiUrl}/odata/Klant?$filter=tolower(Gebruiker/AspNetUserId) eq tolower('${tok.UId}')&$select=Email&$top=1`));
        const res = await fetch(req).then(r => {
          if (r.status != 200) {
            throw `Info ophalen mislukt. HTTP: ${r.status}`;
          }
          return r.json();
        });
        this.info.email = res.value[0].Email;

        this.info.mfaEnabled = await Global.Auth.GetMfaEnabled();
      });
    },
    enableMfa() {
      this.tryInBackground(async () => {
        await Global.Auth.SetMfaEnabled(true);
        Global.Auth.Logout();
      });
    },
    disableMfa() {
      this.tryInBackground(async () => {
        await Global.Auth.SetMfaEnabled(false);
        this.load();
      });
    }
  },
  created() {
    this.load();
  },
  components: {
    'load-overlay': LoadOverlay
  }
});
